import React, { Component } from 'react';
import { compose } from 'redux';
import axios from 'axios';

export class OnlyofficeScreen extends Component {
    async componentDidMount() {
        const contentHash = window.location.pathname.split('/onlyoffice/')[1];
        const response = await axios.get(`/api/2/documents/onlyoffice/info/${contentHash}`);

        const docEditor = new window.DocsAPI.DocEditor("placeholder", {
            document: response.data.document,
            documentType: response.data.documentType,
            editorConfig: response.data.editorConfig,
            token: response.data.token,
            events: {
                onDocumentReady: function () {
                    // const api = docEditor.getApi();
                    // const oDocument = api.GetDocument();
                    // console.log("Document is ready");
                    // ดำเนินการเพิ่มเติมเมื่อเอกสารพร้อมใช้งาน
                },
                onAppReady: function () {
                    // console.log("Application is loaded into the browser");
                    // ดำเนินการเพิ่มเติมเมื่อแอปพลิเคชันโหลดเสร็จ
                },
                // เพิ่ม event handlers อื่น ๆ ตามต้องการ
            },
        });
    }

    render() {
        return (
            <div id="placeholder" ></div>
        );
    }
}

export default compose(
)(OnlyofficeScreen);